export default __webpack_public_path__ + "media/gtm.d85422d1.svg";